import { Link, useLocation } from "react-router";
import { usePhone, useRail } from "../../shared/phone/media";
import { NAV, isNavActive } from "../lib/nav";
import { FlashsuiteMenu } from "./FlashsuiteMenu";
import { BrandWord, Logo } from "./Logo";

/** The prototype's top bar: brand, the four destinations, and Flashsuite's menu. A phone and an iPad have their tabs and rail instead. */
export function TopBar() {
  const { pathname } = useLocation();
  const phone = usePhone();
  const rail = useRail();
  if (phone || rail) return null;

  return (
    <header className="topbar">
      <Link className="brand" to="/command" aria-label="Flashadz home">
        <Logo className="logo mkg" />
        <BrandWord />
      </Link>

      <nav className="topnav" aria-label="Main">
        {NAV.map((item) => (
          <Link key={item.path} to={item.path} className={isNavActive(item, pathname) ? "active" : undefined}>
            {item.label}
          </Link>
        ))}
      </nav>

      <div className="tb-right">
        <FlashsuiteMenu />
      </div>
    </header>
  );
}
